export default __webpack_public_path__ + "static/media/PAFI_Audit Report 2022.4fd90b07.pdf";